
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as contactqm0fzCuwm9rJVuzbwPkQR1aasGv7O2plkJvEsXoEipcMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue?macro=true";
import { default as summarySv0q2k_45Zm25xr8fEFimKPgQ7ESmrQWUCw9ftRKuOK_4Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue?macro=true";
import { default as prescreenJcp9ejrk4rt825zBkBuMbpWgf7AZtqlo3ypmPvh5VosMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue?macro=true";
import { default as applicationBRE2iOsmzQbGhYbFG1k49jQ2w_S3Y_bkft1Xu4cdRlMMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue?macro=true";
import { default as attachmentsI8BsgPTEMPWqkcRoKnsdF0wWAlXy3QkmcK_45mDLOhc0AMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue?macro=true";
import { default as scholarshipT84YYgw1bc8EfggftC7D5crxvT6v4qQtwDyP0MUq0aMMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue?macro=true";
import { default as caseOXAeUv5wCtSOeToP31ylwKyCP5_VSjHPwhqONBXqMykMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case.vue?macro=true";
import { default as index0mUAzE9ip2XE_DkbkgY1CAhaBakqF3pymftc3qw8rqYMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/index.vue?macro=true";
import { default as search_gcT3_T0fFh43DyZlnTFZxV2F9QepdJ8gGhHLEz4gkUMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/search.vue?macro=true";
import { default as new_45caseTRcQwfBH7KzYFswMuYqoNzEVg3dplNAI3nUD_SPXPY4Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/new-case.vue?macro=true";
import { default as indexseIt2JufVfemG5qIluOh33bP54k0Z1yc2aejWzidqQ0Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue?macro=true";
import { default as notificationsyTSC_45xW29MoT93a6G6LD_45OJWd5SSYMNr5eOSKujpIe4Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue?macro=true";
import { default as settingsgZNmocp_45sFICAKr0yEC9gi_458D6vE4BWHV66vjsZRB5IMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings.vue?macro=true";
import { default as usersbcAwX3ectnfVpdMrXfVgINfRQIA5uVCXTE_GTIbq4i0Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue?macro=true";
import { default as _91id_93Kq1wlvIM4EZooL0toz_JLQ_45exmwcKLif55zC4_45z5MsAMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue?macro=true";
import { default as providerlist3T97Uh2QKpqnffKZaOw3yBEVLoemrXGufzT_UndqO9kMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue?macro=true";
import { default as reportsOLBwin77tSjuV1HFLI0SXlVbnIG4QGs4Ix1__gaopSoMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue?macro=true";
import { default as manage_45flags46z6ELXCnpVKC2nsJ7NO6s2ZSnKgWkgdAc4zVlUPuHQMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue?macro=true";
import { default as thank_45youmSuZ6P0k3PplQWDTFM7aT1Ka6k506_450v0GYJoqW2OwYMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue?macro=true";
import { default as thank_45youCaEE7cb8uVO2n62FB8dvWlFn3gRgKIisZP86PfuF7xsMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue?macro=true";
import { default as eligibility7EUgQh_06ZPiTWSNQASWravspzTgnl98_45OLDDfpNJ9MMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue?macro=true";
import { default as case_45assignmentsUFBTrGi476ZWgo3vEG49jr9wphdjcjqXa9_45mdyFN1cwMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue?macro=true";
import { default as income_45eligibilityURw5oF41MqTJQWmIAm6VF3orEfhykX__45Snzd2GyNNogMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue?macro=true";
import { default as scholarship_45age_45dashboardWh9UoaQXOsHgo3eS9d2O6R3_TdWZ__VOMgmpCNbvPi4Meta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue?macro=true";
import { default as scholarship_45end_45date_45dashboardMdp7UI3U50JzIGhPw_45_9s905FzI2s_45vkBykvQFHoWcUMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue?macro=true";
import { default as scholarship_45enrollment_45dashboard0uGb_45OaYG2RQkLUo_2qbpp_45YulQDyGqgq9f6jjdS7IoMeta } from "/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue?macro=true";
export default [
  {
    name: "case",
    path: "/case",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case.vue"),
    children: [
  {
    name: "case-id-contact",
    path: ":id()/contact",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue")
  },
  {
    name: "case-id-summary",
    path: ":id()/summary",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue")
  },
  {
    name: "case-id-prescreen",
    path: ":id()/prescreen",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue")
  },
  {
    name: "case-id-application",
    path: ":id()/application",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue")
  },
  {
    name: "case-id-attachments",
    path: ":id()/attachments",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue")
  },
  {
    name: "case-id-scholarship",
    path: ":id()/scholarship",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/search.vue")
  },
  {
    name: "new-case",
    path: "/new-case",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/new-case.vue")
  },
  {
    name: settingsgZNmocp_45sFICAKr0yEC9gi_458D6vE4BWHV66vjsZRB5IMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue")
  }
]
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(usersbcAwX3ectnfVpdMrXfVgINfRQIA5uVCXTE_GTIbq4i0Meta || {}), ...{"middleware":"admin-access"} },
    alias: ["/csp-admin/users"],
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue")
  },
  {
    name: "report-id",
    path: "/report/:id()",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue")
  },
  {
    name: "providerlist",
    path: "/providerlist",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue")
  },
  {
    name: "csp-admin-reports",
    path: "/csp-admin/reports",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue")
  },
  {
    name: "admin-manage-flags",
    path: "/admin/manage-flags",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue")
  },
  {
    name: "eligible-thank-you",
    path: "/eligible/thank-you",
    meta: thank_45youmSuZ6P0k3PplQWDTFM7aT1Ka6k506_450v0GYJoqW2OwYMeta || {},
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue")
  },
  {
    name: "ineligible-thank-you",
    path: "/ineligible/thank-you",
    meta: thank_45youCaEE7cb8uVO2n62FB8dvWlFn3gRgKIisZP86PfuF7xsMeta || {},
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue")
  },
  {
    name: "public-csp-eligibility",
    path: "/apply/childcare/eligibility",
    meta: eligibility7EUgQh_06ZPiTWSNQASWravspzTgnl98_45OLDDfpNJ9MMeta || {},
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue")
  },
  {
    name: "csp-admin-case-assignments",
    path: "/csp-admin/case-assignments",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue")
  },
  {
    name: "csp-admin-income-eligibility",
    path: "/csp-admin/income-eligibility",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue")
  },
  {
    name: "csp-admin-scholarship-age-dashboard",
    path: "/csp-admin/scholarship-age-dashboard",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-end-date-dashboard",
    path: "/csp-admin/scholarship-end-date-dashboard",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-enrollment-dashboard",
    path: "/csp-admin/scholarship-enrollment-dashboard",
    component: () => import("/codebuild/output/src2544140818/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue")
  }
]